export const ITEMS = [
  "1589687923116363776",
  "1650564255765209088",
  "1648022139151216647",
  "1650819732898041856",
  "1636398855804657664",
  "1613982139103444992",
  "1639726975240511489",
  "1641482810673311763",
];
